export const FINANCIAL_REPORTS_SUCCESS = 'FINANCIAL_REPORTS_SUCCESS';
export const FINANCIAL_REPORTS_COMPLETE_SUCCESS =
  'FINANCIAL_REPORTS_COMPLETE_SUCCESS';
export const FINANCIAL_SUMMARY_REPORTS_COMPLETE_SUCCESS =
  'FINANCIAL_SUMMARY_REPORTS_COMPLETE_SUCCESS';
export const FINANCIAL_REPORTS_FAILED = 'FINANCIAL_REPORTS_FAILED';
export const CALCULATION_REPORTS_COMPLETE_SUCCESS =
  'CALCULATION_REPORTS_COMPLETE_SUCCESS';
export const TARGET_REPORTS_COMPLETE_SUCCESS =
  'TARGET_REPORTS_COMPLETE_SUCCESS';
export const CONTRACT_CHANGE_REPORTS_COMPLETE_SUCCESS =
  'CONTRACT_CHANGE_REPORTS_COMPLETE_SUCCESS';
export const FINACIAL_POSTING_APPROVAL_DATA_COMPLETE_SUCCESS =
  'FINACIAL_POSTING_APPROVAL_DATA_COMPLETE_SUCCESS';
export const FINANCIAL_SUMMARY_COMPLETE_SUCCESS =
  'FINANCIAL_SUMMARY_COMPLETE_SUCCESS';
export const CALCULATION_REPORTS_SUCCESS = 'CALCULATION_REPORTS_SUCCESS';
export const FINANCIAL_SUMMARY_REPORTS_COMPLETE_FAILED =
  'FINANCIAL_SUMMARY_REPORTS_COMPLETE_FAILED';
export const TARGET_REPORTS_SUCCESS = 'TARGET_REPORTS_SUCCESS';
export const RATIO_KEY_FIGURES_REPORTS_SUCCESS =
  'RATIO_KEY_FIGURES_REPORTS_SUCCESS';
export const INCENTIVE_RATIO_TREND_REPORTS_SUCCESS =
  'INCENTIVE_RATIO_TREND_REPORTS_SUCCESS';
export const TOP_N_ATTRIBUTES_REPORTS_SUCCESS =
  'TOP_N_ATTRIBUTES_REPORTS_SUCCESS';
export const DUPLICATE_PAYMENT_REPORTS_SUCCESS =
  'DUPLICATE_PAYMENT_REPORTS_SUCCESS';
export const ANAMOLY_REPORTS_SUCCESS = 'ANAMOLY_REPORTS_SUCCESS';
export const APPROVAL_POSTING_HISTORY_REPORTS_SUCCESS =
  'APPROVAL_POSTING_HISTORY_REPORTS_SUCCESS';
export const CONTRACT_SEARCH_BY_CUSTOMER = 'CONTRACT_SEARCH_BY_CUSTOMER';
export const EXCEPTION_SEARCH_BY_CUSTOMER = 'EXCEPTION_SEARCH_BY_CUSTOMER';
export const SAVE_SIMULATION_STATE = 'SAVE_SIMULATION_STATE';
export const CLEAR_SIMULATION_STATE = 'CLEAR_SIMULATION_STATE';
export const CLEAR_EXCEPTION_SEARCH_BY_CUSTOMER = 'CLEAR_EXCEPTION_SEARCH_BY_CUSTOMER';
export const SIMULATE_REBATE_ESTIMATOR = 'SIMULATE_REBATE_ESTIMATOR';
export const CLEAR_SIMULATE_REBATE_ESTIMATOR = 'CLEAR_SIMULATE_REBATE_ESTIMATOR';
export const SAVE_SIMULATE_REBATE_ESTIMATOR_STATE = 'SAVE_SIMULATE_REBATE_ESTIMATOR_STATE';
export const CLEAR_SIMULATE_REBATE_ESTIMATOR_STATE = 'CLEAR_SIMULATE_REBATE_ESTIMATOR_STATE';
export const FORMULA_EXCEPTION = 'FORMULA_EXCEPTION';
export const CLEAR_FORMULA_EXCEPTION = 'CLEAR_FORMULA_EXCEPTION';
export const EXCEPTION_FETCH_START = 'EXCEPTION_FETCH_START';
export const EXCEPTION_FETCH_END = 'EXCEPTION_FETCH_END';
export const CALCULATION_FORMULA_VALUES_REPORTS_SUCCESS =
  'CALCULATION_FORMULA_VALUES_REPORTS_SUCCESS';
export const CONTRACT_CHANGE_REPORTS_SUCCESS =
  'CONTRACT_CHANGE_REPORTS_SUCCESS';
export const FINANCIAL_SUMMARY_SUCCESS = 'FINANCIAL_SUMMARY_SUCCESS';
export const GET_DATAGRID_METADATA_SUCCESS = 'GET_DATAGRID_METADATA_SUCCESS';
export const CALCULATION_REPORTS_FAILED = 'CALCULATION_REPORTS_FAILED';
export const GET_REPORT_LIST_DATA_SUCCESS = 'GET_REPORT_LIST_DATA_SUCCESS';
export const TARGET_REPORTS_FAILED = 'TARGET_REPORTS_FAILED';
export const CONTRACT_CHANGE_REPORTS_FAILED = 'CONTRACT_CHANGE_REPORTS_FAILED';
export const FINANCIAL_SUMMARY_FAILED = 'FINANCIAL_SUMMARY_FAILED';
export const INVOICE_REPORTS_SUCCESS = 'INVOICE_REPORTS_SUCCESS';
export const INVOICE_REPORTS_COMPLETE_SUCCESS =
  'INVOICE_REPORTS_COMPLETE_SUCCESS';
export const INVOICE_REPORTS_FAILED = 'INVOICE_REPORTS_FAILED';
export const CONTRACT_REPORTS_SUCCESS = 'CONTRACT_REPORTS_SUCCESS';
export const CONTRACT_REPORTS_COMPLETE_SUCCESS =
  'CONTRACT_REPORTS_COMPLETE_SUCCESS';
export const CONTRACT_REPORTS_FAILED = 'CONTRACT_REPORTS_FAILED';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const CONTRACT_REPORTS_OVERLAP_SUCCESS =
  'CONTRACT_REPORTS_OVERLAP_SUCCESS';
export const DYNAMIC_QUERY_FIELDS_SUCCESS = 'DYNAMIC_QUERY_FIELDS_SUCCESS';
export const DYNAMIC_QUERY_FIELDS_SUCCESS_NEW =
  'DYNAMIC_QUERY_FIELDS_SUCCESS_NEW';
export const QUERY_LIST_SUCCESS = 'QUERY_LIST_SUCCESS';
export const QUERY_LIST_CLEAR = 'QUERY_LIST_CLEAR';
export const QUERY_RESULTS_FINAL_SUCCESS = 'QUERY_RESULTS_FINAL_SUCCESS';
export const ALERT_MANAGEMENT_REPORT_SUCCESS = 'ALERT_MANAGEMENT_REPORT_SUCCESS';
export const DYNAMIC_FILTER_API_SUCCESS = 'DYNAMIC_FILTER_API_SUCCESS';
export const DYNAMIC_QUERY_DETAILS_SUCCESS = 'DYNAMIC_QUERY_DETAILS_SUCCESS';
export const DYNAMIC_QUERY_FIELDS_SALES_DATA_SUCCESS =
  'DYNAMIC_QUERY_FIELDS_SALES_DATA_SUCCESS';
export const CLAIMS_FORMAT_FIELDS_SUCCESS = 'CLAIMS_FORMAT_FIELDS_SUCCESS';
export const INCOMING_CLAIM_DETAILS_SUCCESS = 'INCOMING_CLAIM_DETAILS_SUCCESS';
export const CALCULATION_SIMULATION_FIELDS_SUCCESS =
  'CALCULATION_SIMULATION_FIELDS_SUCCESS';
export const QUERY_LIST_ADMIN_SUCCESS = 'QUERY_LIST_ADMIN_SUCCESS';
export const QUERY_TYPES_SUCCESS = 'QUERY_TYPES_SUCCESS';
export const PURCHASE_DATA_FIELDS_SUCCESS = 'PURCHASE_DATA_FIELDS_SUCCESS';
export const LOAD_TARGET_DATA = 'LOAD_TARGET_DATA';
export const COLL_PORTAL_CUST_SUPP = 'COLL_PORTAL_CUST_SUPP';
export const OUTGOING_CLAIMS_FORMAT_FIELDS_SUCCESS =
  'OUTGOING_CLAIMS_FORMAT_FIELDS_SUCCESS';
export const OUTGOING_CLAIM_DETAILS_SUCCESS = 'OUTGOING_CLAIM_DETAILS_SUCCESS';
export const GET_ALL_ORG_USERS = 'GET_ALL_ORG_USERS';
export const TABLE_DETERMINATION_SUCCESS = 'TABLE_DETERMINATION_SUCCESS';
export const PREDEFINED_QUERY_RESULTS_FINAL_SUCCESS =
  'PREDEFINED_QUERY_RESULTS_FINAL_SUCCESS';
export const PREDEFINED_QUERY_DETAILS_SUCCESS =
  'PREDEFINED_QUERY_DETAILS_SUCCESS';
export const CUSTOM_VIEW = 'CUSTOM_VIEW';
export const GET_FILTER_VALUES_SUCCESS = 'GET_FILTER_VALUES_SUCCESS';
export const BATCH_JOB_FILTERS = 'BATCH_JOB_FILTERS';
export const DYNAMIC_QUERY_FILTER = 'DYNAMIC_QUERY_FILTER';
export const DYNAMIC_QUERY_FILTER_BY_ID = 'DYNAMIC_QUERY_FILTER_BY_ID';
export const RECONCILE_INTEGRATION_SUCCESS = 'RECONCILE_INTEGRATION_SUCCESS';
export const FILTER_VALUES_BY_ID = 'FILTER_VALUES_BY_ID';
export const CONTRACT_HISTORY_APPROVAL_SUCCESS =
  'CONTRACT_HISTORY_APPROVAL_SUCCESS';
export const DOCUMENT_HISTORY_APPROVAL_SUCCESS =
  'DOCUMENT_HISTORY_APPROVAL_SUCCESS';
export const NTE_LIFE_TIME_SUCCESS = 'NTE_LIFE_TIME_SUCCESS';
export const OUTGOING_CLAIMS_REPORT_SUCCESS = 'OUTGOING_CLAIMS_REPORT_SUCCESS';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const GET_CUSTOM_TABLES = 'GET_CUSTOM_TABLES';
export const GET_FILTER_CONFIGURATIONS = 'GET_FILTER_CONFIGURATIONS';
export const GET_FILTER_CONFIGURATIONS_BY_PAGE = 'GET_FILTER_CONFIGURATIONS_BY_PAGE';
export const EXECUTE_FILTER_VALUES_SUCCESS = 'EXECUTE_FILTER_VALUES_SUCCESS';
export const ADD_MATERIAL_DESIGN = 'ADD_MATERIAL_DESIGN';
export const VIEW_MATERIAL_DESIGN_SUCCESS = 'VIEW_MATERIAL_DESIGN_SUCCESS';
export const CLEAR_MATERIAL_DESIGN_VIEW = 'CLEAR_MATERIAL_DESIGN_VIEW';
export const DELETE_MATERIAL_DESIGN = 'DELETE_MATERIAL_DESIGN';
export const DELETE_MATERIAL_DESIGN_START = 'DELETE_MATERIAL_DESIGN_START';
export const DELETE_MATERIAL_DESIGN_SUCCESS = 'DELETE_MATERIAL_DESIGN_SUCCESS';
export const DELETE_MATERIAL_DESIGN_FAIL = 'DELETE_MATERIAL_DESIGN_FAIL';
export const DELETE_MATERIAL_DESIGN_END = 'DELETE_MATERIAL_DESIGN_END';
export const UPDATE_DELETE_PROGRESS = 'UPDATE_DELETE_PROGRESS';
export const DELETE_MATERIAL_MASTER_FAIL = 'DELETE_MATERIAL_MASTER_FAIL';
export const DELETE_MATERIAL_DESIGN_FAILED = 'DELETE_MATERIAL_DESIGN_FAILED';
export const DELETE_MATERIAL_MASTER_SUCCESS = 'DELETE_MATERIAL_MASTER_SUCCESS';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const DELETE_SUPPLIER_DESIGN_SUCCESS = 'DELETE_SUPPLIER_DESIGN_SUCCESS';
export const DELETE_SUPPLIER_DESIGN_FAIL = 'DELETE_SUPPLIER_DESIGN_FAIL';
export const DELETE_PRODUCT_MATERIAL_DESIGN_SUCCESS =
  'DELETE_PRODUCT_MATERIAL_DESIGN_SUCCESS';
export const DELETE_PRODUCT_MATERIAL_DESIGN_FAIL =
  'DELETE_PRODUCT_MATERIAL_DESIGN_FAIL';
export const DELETE_CUSTOMER_DESIGN_SUCCESS = 'DELETE_CUSTOMER_DESIGN_SUCCESS';
export const DELETE_EMPLOYEE_DESIGN_FAIL = 'DELETE_EMPLOYEE_DESIGN_FAIL';
export const DELETE_EMPLOYEE_DESIGN_SUCCESS = 'DELETE_EMPLOYEE_DESIGN_SUCCESS';
export const DELETE_CUSTOMER_DESIGN_FAIL = 'DELETE_CUSTOMER_DESIGN_FAIL';
export const DELETE_CUSTOM_TABLE_SUCCESS = 'DELETE_CUSTOM_TABLE_SUCCESS';
export const DELETE_FILTER_CONFIGURATION_SUCCESS =
  'DELETE_FILTER_CONFIGURATION_SUCCESS';
export const DELETE_FILTER_CONFIGURATION_FAIL =
  'DELETE_FILTER_CONFIGURATION_FAIL';
export const DELETE_CUSTOM_TABLE_FAIL = 'DELETE_CUSTOM_TABLE_FAIL';
export const GET_MATERIAL_BY_PROFILE_SUCCESS =
  'GET_MATERIAL_BY_PROFILE_SUCCESS';
export const GET_EMPLOYEE_BY_PROFILE_SUCCESS =
  'GET_EMPLOYEE_BY_PROFILE_SUCCESS';
export const GET_CUSTOM_TABLE_BY_ID_SUCCESS = 'GET_CUSTOM_TABLE_BY_ID_SUCCESS';
export const GET_FILTER_CONFIGURATION_BY_ID_SUCCESS =
  'GET_FILTER_CONFIGURATION_BY_ID_SUCCESS';
export const GET_COLLABORATION_BY_ID_SUCCESS = "GET_COLLABORATION_BY_ID_SUCCESS";
export const MEMBERSHIP_TABLE_SUCCESS = 'MEMBERSHIP_TABLE_SUCCESS';
export const CLONE_SUPPLIER_MASTER_SUCCESS = 'CLONE_SUPPLIER_MASTER_SUCCESS';
export const CLONE_MATERIAL_MASTER_SUCCESS = 'CLONE_MATERIAL_MASTER_SUCCESS';
export const CLONE_EMPLOYEE_MASTER_SUCCESS = 'CLONE_EMPLOYEE_MASTER_SUCCESS';
export const ADD_MATERIAL_DESIGN_SUCCESS = 'ADD_MATERIAL_DESIGN_SUCCESS';
export const ADD_CUSTOM_TABLE_SUCCESS = 'ADD_CUSTOM_TABLE_SUCCESS';
export const ADD_FILTER_CONFIGURATION_SUCCESS =
  'ADD_FILTER_CONFIGURATION_SUCCESS';
export const COPY_SUPPLIER_PROFILE_SUCCESS = 'COPY_SUPPLIER_PROFILE_SUCCESS';
export const COPY_SUPPLIER_PROFILE_FAIL = 'COPY_SUPPLIER_PROFILE_FAIL';
export const SET_CUSTOMER_PROFILE_DEFAULT_SUCCESS =
  'SET_CUSTOMER_PROFILE_DEFAULT_SUCCESS';
export const SET_CUSTOMER_PROFILE_DEFAULT_FAIL =
  'SET_CUSTOMER_PROFILE_DEFAULT_FAIL';
export const SET_EMPLOYEE_PROFILE_DEFAULT_SUCCESS =
  'SET_EMPLOYEE_PROFILE_DEFAULT_SUCCESS';
export const SET_EMPLOYEE_PROFILE_DEFAULT_FAIL =
  'SET_EMPLOYEE_PROFILE_DEFAULT_FAIL';
export const SET_MATERIAL_PROFILE_DEFAULT_SUCCESS =
  'SET_MATERIAL_PROFILE_DEFAULT_SUCCESS';
export const SET_MATERIAL_PROFILE_DEFAULT_FAIL =
  'SET_MATERIAL_PROFILE_DEFAULT_FAIL';
export const SET_SUPPLIER_PROFILE_DEFAULT_SUCCESS =
  'SET_SUPPLIER_PROFILE_DEFAULT_SUCCESS';
export const SET_SUPPLIER_PROFILE_DEFAULT_FAIL =
  'SET_SUPPLIER_PROFILE_DEFAULT_FAIL';

export const GET_CONTROL_CONFIG_SUCCESS = 'GET_CONTROL_CONFIG_SUCCESS';
export const CONTROL_CONFIG_DATA_SUCCESS = 'CONTROL_CONFIG_DATA_SUCCESS';
export const SUPPLIER_REBATE_ACCRUAL_POSTING_RESULTS_SUCCESS = 'SUPPLIER_REBATE_ACCRUAL_POSTING_RESULTS_SUCCESS';
export const POSTINGS_RESULTS_SUCCESS = 'POSTINGS_RESULTS_SUCCESS';
export const EXECUTE_REPORT_SUCCESS = "EXECUTE_REPORT_SUCCESS";
export const CLEAR_EXECUTE_REPORT = "CLEAR_EXECUTE_REPORT";
